/**
 * @name appSettings
 * @description
 * This is config file, it include only global application related settings
 * Define Settings the object way(based on requirement):
 * @example {paramsName}:{value}
 * @constant appSettings
 * @type {CommonBase}
 */

import { CommonBase } from '@core/interfaces/common-base';

export const appSettings: CommonBase = {
  appTitle: 'Podcast',
  appLogo: '',
};

export const APP_NAME = 'Podcast';
export const PAGINATOR_SIZE = 10;
export const PAGINATOR_SIZE_OPTIONS = [10, 20, 30, 40, 50];
export const ASSETS_BASE_PATH = 'assets/images/';
export const FULL_DATE = 'dd/mm/yyyy, h:mm a';
export const COMMON_DATE_FORMAT = 'dd/MM/yyyy';
export const MONTH_YEAR = 'MMM yyyy';

export const TOKEN_NAME = 'api_token'; // Local storage Key where user JWT token stored
export const TOKEN_HEADER_KEY = 'Authorization'; // JWT token header name
// JWT token header name. It depends on your application, which header need to used. Modify it per needed.
export const AUTH_PREFIX = 'Bearer';
export const USER_STORAGE_KEY = 'user'; // Local storage Key name where login user detail stored
export const ROLE_KEY = 'roles'; //  Local storage Key name where login user roles stored, if any.
export const DM_PREFIX = 'CB_APP_'; // Any prefix to use for local storage to make it unique
export const APP_USER = 'CB_APP_USER'; // Local storage Key name where login user all detail stored
export const CB_APP_CONSTRAINTS = 'CB_APP_CONSTRAINTS'; // Local storage Key name where login user all detail stored
export const SESSION_LINK = 'session/link'; // inivite link
export const JOIN_AS = 'joinAs'
export const IS_GO_LIVE = 'isGolive'
export const ENTER_ROOM = 'enter-room'
export const META_INFO_LS = 'UploadMetaInfo';
export const MIME_TYPE = 'video/x-matroska'; //video/x-matroska
export const EXPIRE_REM = 'expireRem'
export const CHUNK_SIZE = 5242999;
export const INSTANCE_SESSION = 'INSTANCE_SESSION';
export const DEVICES = {
  MIC: 'microphone',
  CAM: 'camera',
  both: function () { return `${DEVICES.MIC}/${DEVICES.CAM}` }
}

/**
 * video constraint for webrtc config
 */
export const VIDEO_CONSTRAINT = {
  deviceId: '',
  frameRate: 24,
  width: 852,// 3840
  height: 480, //2160
  resizeMode: 'none',
  aspectRatio: 1.7777777778,
}

/**
 * audio constraint
 */
export const AUDIO_CONSTRAINT = {
  sampleRate: 48000,
  deviceId: '',
  echoCancellation: true,
  noiseSuppression: true,
  autoGainControl: true
}

/**
 * audio output constraint
 */
export const AUDIO_OUTPUT_CONSTRAINT = {
  deviceId: '',
}

/**
 * regular expresssion for validation 
 */
export const REGEX = {
  name: /^[_.A-z ]*((-|)*[_.A-z])*$/,
  password: /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[`!”?$?%^&*()_–+={[}\]:;@‘~#|\<,>.?\/])[A-Za-z\d`!”?$?%^&*()_–+={[}\]:;@‘~#|\<,>.?\/]{8,33}/g,
  joinName: /^[^<>:;,?"*|/{}=\\?+&^%$#@!~`[\]]+$/g
}

/**
 * default layout configuration for conference and customization setting
 */
export var layouts = {
  p2: '23',
  p3: '35',
  p4: '42',
  p5: '51',
  p6: '63'
}
